(function () {
  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var items = qsa('[data-cb-megamenu-item]');
    var closeTimer = null;

    function closeMenus(except) {
      window.clearTimeout(closeTimer);
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var trigger = qs('[data-cb-megamenu-trigger]', item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      if (!except) document.body.classList.remove('cb-megamenu-open');
    }

    function openMenu(item) {
      var trigger = qs('[data-cb-megamenu-trigger]', item);
      closeMenus(item);
      item.classList.add('is-open');
      document.body.classList.add('cb-megamenu-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function toggleMenu(item) {
      if (item.classList.contains('is-open')) {
        closeMenus();
      } else {
        openMenu(item);
      }
    }

    items.forEach(function (item) {
      var trigger = qs('[data-cb-megamenu-trigger]', item);

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        window.clearTimeout(closeTimer);
        openMenu(item);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        closeTimer = window.setTimeout(function () {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (!qs('[data-cb-megamenu-item].is-open')) {
            document.body.classList.remove('cb-megamenu-open');
          }
        }, 180);
      });

      if (trigger) {
        trigger.addEventListener('focus', function () {
          if (!isDesktop()) return;
          openMenu(item);
        });
      }

      qsa('[data-cb-megamenu-tab]', item).forEach(function (tab) {
        function activate() {
          var target = tab.getAttribute('data-cb-megamenu-tab');
          qsa('[data-cb-megamenu-tab]', item).forEach(function (otherTab) {
            otherTab.classList.toggle('is-active', otherTab === tab);
          });
          qsa('[data-cb-megamenu-panel]', item).forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-cb-megamenu-panel') === target);
          });
        }

        tab.addEventListener('mouseenter', activate);
        tab.addEventListener('focus', activate);
        tab.addEventListener('click', activate);
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cb-megamenu-item]')) closeMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenus();
    });
  });
})();
